(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maentae-blog-search"] && !Shopify.designMode) return;
  try {
    class MaentaeBlogSearch extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.maentae-blog-search__form');
      this.input = this.querySelector('.maentae-blog-search__input');
      this.clearButton = this.querySelector('.maentae-blog-search__clear');
      this.results = this.querySelector('.maentae-blog-search__results');
      this.blogHandle = this.dataset.blogHandle;
      this.noResultsMessage = this.dataset.noResults;
      this.errorMessage = this.dataset.error;
      this.abortController = null;
      this.debounceTimer = null;

      if (!this.form || !this.input || !this.results || !this.blogHandle) return;

      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (event) => this.onKeydown(event));

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        window.clearTimeout(this.debounceTimer);

        const query = this.input.value.trim();
        if (query.length >= 2) this.search(query);
      });

      this.form.addEventListener('reset', (event) => {
        event.preventDefault();
        this.input.value = '';
        this.toggleClearButton();
        this.closeResults();
        this.input.focus();
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeResults();
      });

      this.toggleClearButton();
    }

    disconnectedCallback() {
      window.clearTimeout(this.debounceTimer);
      if (this.abortController) this.abortController.abort();
    }

    onInput() {
      window.clearTimeout(this.debounceTimer);
      this.toggleClearButton();

      const query = this.input.value.trim();

      if (query.length < 2) {
        this.closeResults();
        return;
      }

      this.debounceTimer = window.setTimeout(() => {
        this.search(query);
      }, 220);
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closeResults();
        this.input.focus();
      }
    }

    toggleClearButton() {
      if (!this.clearButton) return;
      this.clearButton.hidden = this.input.value.length === 0;
    }

    async search(query) {
      if (query.length < 2) {
        this.closeResults();
        return;
      }

      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      const root = window.Shopify?.routes?.root || '/';
      const params = new URLSearchParams();

      params.set('q', query);
      params.set('resources[type]', 'article');
      params.set('resources[limit]', '10');
      params.set('resources[limit_scope]', 'all');
      params.set('resources[options][fields]', 'title,body,tag');

      try {
        const response = await fetch(`${root}search/suggest.json?${params.toString()}`, {
          signal: this.abortController.signal,
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Predictive search failed: ${response.status}`);
        }

        const data = await response.json();
        const articles = data?.resources?.results?.articles || [];
        const expectedPrefix = `/blogs/${this.blogHandle}/`;

        const matchingArticles = articles.filter((article) => {
          if (!article?.url) return false;

          try {
            const articleUrl = new URL(article.url, window.location.origin);
            return articleUrl.pathname.startsWith(expectedPrefix);
          } catch {
            return false;
          }
        });

        this.renderResults(matchingArticles);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.renderMessage(this.errorMessage);
      }
    }

    renderResults(articles) {
      this.results.replaceChildren();

      if (articles.length === 0) {
        this.renderMessage(this.noResultsMessage);
        return;
      }

      const fragment = document.createDocumentFragment();

      articles.forEach((article) => {
        const link = document.createElement('a');
        link.className = 'maentae-blog-search__result';
        link.href = article.url;
        link.setAttribute('role', 'option');

        const imageWrap = document.createElement('div');
        imageWrap.className = 'maentae-blog-search__result-image-wrap';

        if (article.image) {
          const image = document.createElement('img');
          image.className = 'maentae-blog-search__result-image';
          image.src = article.image;
          image.alt = '';
          image.loading = 'lazy';
          imageWrap.append(image);
        }

        link.append(imageWrap);

        const content = document.createElement('div');
        content.className = 'maentae-blog-search__result-content';

        const topic = this.getTopic(article.tags || []);
        if (topic) {
          const topicElement = document.createElement('p');
          topicElement.className = 'maentae-blog-search__result-topic';
          topicElement.textContent = topic;
          content.append(topicElement);
        }

        const title = document.createElement('p');
        title.className = 'maentae-blog-search__result-title';
        title.textContent = article.title;
        content.append(title);

        if (article.published_at) {
          const date = document.createElement('time');
          date.className = 'maentae-blog-search__result-date';
          date.dateTime = article.published_at;
          date.textContent = this.formatDate(article.published_at);
          content.append(date);
        }

        link.append(content);
        fragment.append(link);
      });

      this.results.append(fragment);
      this.openResults();
    }

    getTopic(tags) {
      const topics = [
        'Learning Experience Design',
        'Industry Trends & Insights',
        'Leadership & Strategy'
      ];

      return topics.find((topic) => tags.includes(topic)) || '';
    }

    formatDate(value) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';

      return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }).format(date);
    }

    renderMessage(message) {
      this.results.replaceChildren();

      const paragraph = document.createElement('p');
      paragraph.className = 'maentae-blog-search__message';
      paragraph.textContent = message;

      this.results.append(paragraph);
      this.openResults();
    }

    openResults() {
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    closeResults() {
      this.results.hidden = true;
      this.results.replaceChildren();
      this.input.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('maentae-blog-search')) {
    customElements.define('maentae-blog-search', MaentaeBlogSearch);
  }
  } catch(e) { console.error(e); }
})();

})();
